import { createAction, props } from '@ngrx/store';
import { CreateSupplier, Supplier } from '../../models/supplier';

export enum SuppliersActionTypes {
  LoadSuppliers = '[Suppliers] Get Suppliers',
  LoadSuppliersSuccess = '[Suppliers] Get Suppliers Success',
  LoadSuppliersError = '[Suppliers] Get Suppliers Error',
  CreateSupplier = '[Suppliers] Create Supplier',
  CreateSuppliersSuccess = '[Suppliers] Create Supplier Success',
  CreateSuppliersError = '[Suppliers] Create Supplier Error',
  UpdateSupplier = '[Suppliers] Update Supplier',
  UpdateSupplierSuccess = '[Suppliers] Update Supplier Success',
  UpdateSupplierError = '[Suppliers] Update Supplier Error',
  SuppliersCleanup = '[Suppliers] Suppliers Cleanup',
}

export const getSuppliers = createAction(
  SuppliersActionTypes.LoadSuppliers,
);

export const getSuppliersSuccess = createAction(
  SuppliersActionTypes.LoadSuppliersSuccess,
  props<{ suppliers: Supplier[] }>(),
);

export const getSuppliersError = createAction(
  SuppliersActionTypes.LoadSuppliersError,
  props<{ errorMessage: string }>(),
);

export const createSupplier = createAction(
  SuppliersActionTypes.CreateSupplier,
  props<{ supplier: CreateSupplier }>(),
);

export const createSupplierSuccess = createAction(
  SuppliersActionTypes.CreateSuppliersSuccess,
  props<{ supplier: Supplier }>(),
);

export const createSupplierError = createAction(
  SuppliersActionTypes.CreateSuppliersError,
  props<{ errorMessage: string }>(),
);


export const updateSupplier = createAction(
  SuppliersActionTypes.UpdateSupplier,
  props<{ supplier: Partial<CreateSupplier> & { id: number } }>(),
);

export const updateSupplierSuccess = createAction(
  SuppliersActionTypes.UpdateSupplierSuccess,
  props<{ supplier: Supplier }>(),
);

export const updateSupplierError = createAction(
  SuppliersActionTypes.CreateSuppliersError,
  props<{ errorMessage: string }>(),
);

export const cleanUpSuppliers = createAction(
  SuppliersActionTypes.SuppliersCleanup,
);
